module.exports = __webpack_public_path__ + "static/media/SF UI  Text.888e0f3f.otf";